    angular.module("ainapp")
        .controller("financialDashController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
                function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


                $scope.PageName = "Financial Dashboard";
                $scope.TokenInfo = AuthenticationService.getTokenInfo();
                if ($scope.TokenInfo == null) {
                    $state.go("login");
                } else {
                    $scope.checkUserPageAccess($scope.PageName);
                }

                $scope.Init = function () {

                    $scope.CashBalanceTotal = 0;
                    $scope.BankBalanceTotal = 0;
                    $scope.ReceivableTotal = 0;
                    $scope.PayableTotal = 0;
                    $scope.InventoryTotal = 0;
                    $scope.InventoryTotalMain = 0;

                    $scope.dashcounts = [];
                    MainService.FinancialDashboardCounts().then(function (response) {
                        $scope.dashcounts = response.data;
                    }, function () {})

                    $scope.CashBalance = [];
                    MainService.GetCashBalanceDashboard().then(function (response) {
                        $scope.CashBalance = response.data;
                        angular.forEach($scope.CashBalance, function (e) {
                            $scope.CashBalanceTotal = $scope.CashBalanceTotal + e.Balance;
                        })
                    }, function () {})

                    $scope.BankBalance = [];
                    MainService.GetBankBalanceDashboard().then(function (response) {
                        $scope.BankBalance = response.data;
                        angular.forEach($scope.BankBalance, function (e) {
                            $scope.BankBalanceTotal = $scope.BankBalanceTotal + e.Balance;
                        })
                    }, function () {})

                    $scope.ReceivableBalance = [];
                    MainService.GetTotalReceivableDashboard().then(function (response) {
                        $scope.ReceivableBalance = response.data;
                        angular.forEach($scope.ReceivableBalance, function (e) {
                            $scope.ReceivableTotal = $scope.ReceivableTotal + e.Balance;
                        })
                    }, function () {})


                    $scope.PayableBalance = [];
                    MainService.GetTotalPayableDashboard().then(function (response) {
                        $scope.PayableBalance = response.data;
                        angular.forEach($scope.PayableBalance, function (e) {
                            $scope.PayableTotal = $scope.PayableTotal + e.Balance;
                        })
                    }, function () {})

                    $scope.InventoryBalance = [];
                    MainService.GetTotalInventoryDashboard().then(function (response) {
                        $scope.InventoryBalance = response.data;
                        angular.forEach($scope.InventoryBalance, function (e) {
                            $scope.InventoryTotal = $scope.InventoryTotal + e.Balance;
                        })
                    }, function () {})

                    $scope.InventoryBalanceMain = [];
                    MainService.GetTotalInventoryDashboardMainGroup().then(function (response) {
                        $scope.InventoryBalanceMain = response.data;
                        angular.forEach($scope.InventoryBalanceMain, function (e) {
                            $scope.InventoryTotalMain = $scope.InventoryTotal + e.Balance;
                        })
                    }, function () {})



                }
                $scope.Init();

                        }])
